import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helper } from '../Common/Helpers/helper';

@Component({
	standalone: false,
	selector: 'non-supported-browser',
	template: `
		<div class="notSupportedToastContainer">
			<div class="notSupportedToast" *ngIf="browserIsNotSupported">
				<p>{{ 'LicenceHolder.Common.Phrase.BrowserNotSupported' | translate }}</p>
			</div>
			<div class="notSupportedToast" *ngIf="versionIsNotSupported">
				<p>{{ 'LicenceHolder.Common.Phrase.VersionNotSupported' | translate }}</p>
			</div>
		</div>
	`,
	styleUrls: ['../Css/Components/non-supported-browser.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class NonSupportedBrowser implements OnInit {
	public browserIsNotSupported = false;
	public versionIsNotSupported = false;

	constructor(private helper: Helper) {
		// Empty
	}

	ngOnInit() {
		//Also checks to make sure that the user is not on iOS or Android, which the popup is not designed for and could therefore block important functionality
		this.browserIsNotSupported = !(
			platform.name === 'Firefox' ||
			platform.name === 'Chrome' ||
			platform.name === 'Microsoft Edge' ||
			this.helper.is.ios() ||
			this.helper.is.android()
		);

		if (navigator.userAgent.includes('Edg/')) {
			const [major, _, patch] = platform.version.split('.').map((version) => parseInt(version, 10));

			// 83.0.4
			if (major < 83 && patch < 4) {
				this.versionIsNotSupported = true;
			}
		}
	}
}
